import { reduxType } from "../../interfaces/reducerType"
const defaultState: any = {
    page: 1,
    pageSize: 5,
};
function reducer(state = defaultState, { type, payload }: reduxType) {
    switch (type) {
        case "paginationState":
            return payload
        default:
            return state;
    }
}
export default reducer;